import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Product } from '@core/models/piramide/Product';
import compatibilidades from '../../../assets/compatibilidades.json';
import { ProductInCompatibility } from '@core/services/CompatibilityHandler/productInCompatibility';
import { DatosArmado } from '@core/models/datosArmado';
import { ArmaPc } from '@core/models/ArmaPc';
import { DataArmado } from '@core/services/CompatibilityHandler/funcionesArmado/DataArmado';
import { FuncionesArmadoAgrupador } from '@core/services/CompatibilityHandler/funcionesArmado/FuncionesArmadoAgrupador';
import { ArmaPcDataService } from '../../arma-pc/services/arma-pc-data.service';
import { Incompatibilities } from '@core/services/CompatibilityHandler/Incompatibilities';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class ArmadoRelacionesService {
  public productosObs = new BehaviorSubject<ProductInCompatibility<Product>[]>([]);
  public productosObs$ = this.productosObs.asObservable();
  private productos: ArmaPc;
  private compatibilidadesJson = compatibilidades;
  prodIncompatibles: Array<any> = [];
  constructor(
    public funcionesArmadoAgrupador: FuncionesArmadoAgrupador,
    private armaPcData: ArmaPcDataService,
    private http: HttpClient,
  ) {
    this.armaPcData.obtenerProductosIncompatibles$.subscribe(
      (res) => (this.prodIncompatibles = res),
    );
  }
  getDataJson(): Observable<any> {
    return this.http.get<any>(`${environment.assets}compatibilidades.json`);
  }

  /**
   * Renueva las incompatibilidades de una producto in compatibility un armado.
   *
   * nota: esta función devuelve por referencia el productoAValidar,
   * pero en el proceso lo transforma y le renueva las incompatibilidades
   * En principio eta función tiene varias responsabiles. separaría la función en dos.
   * Una que te tire la lista de incompatibildades dado un producto y un armado
   * y otra función que te renueve estas incompatibildades. Lo importante es la que primera
   * sea más facilmente testeable. Es una idea. no es indisponesable
   *
   * @param productosAValidar se pasa por referencia
   * @param armado
   * @returns devuelve el mismo tipo
   */
  public validarProductos(
    productosAValidar: ProductInCompatibility<Product>[],
    armado: DataArmado,
  ) {
    return productosAValidar.map((productoAValidar) => {
      let incompatibilidades: Array<Incompatibilities>;

      incompatibilidades = this.chequearIncompatibilidadesManuales(productoAValidar, armado);
      if (!incompatibilidades?.length) {
        incompatibilidades = this.funcionesArmadoAgrupador.ejecutar(
          armado,
          productoAValidar.product,
        );
      }

      productoAValidar.incompatibilities = [
        ...productoAValidar.incompatibilities,
        ...incompatibilidades,
      ];
      return productoAValidar;
    });
  }
  public chequearIncompatibilidadesManuales(
    producto: ProductInCompatibility<Product>,
    armado: DataArmado,
  ): Array<Incompatibilities> {
    const incompatibilidadesNuevas: Array<Incompatibilities> = [];
    const listaIncompatibilidadesManuales = this.prodIncompatibles.filter(
      (prod) =>
        (prod.idProductoA == producto.product.id_producto ||
          prod.idProductoB == producto.product.id_producto) &&
        prod.activo == true,
    );
    if (!listaIncompatibilidadesManuales?.length) {
      return [];
    }
    listaIncompatibilidadesManuales.forEach((incomp) => {
      for (const componente in armado) {
        if (
          armado[componente].some(
            (productoEnArmado) =>
              (productoEnArmado.id_producto == incomp.idProductoA &&
                incomp.idProductoB == producto.product.id_producto) ||
              (productoEnArmado.id_producto == incomp.idProductoB &&
                incomp.idProductoA == producto.product.id_producto),
          )
        ) {
          incompatibilidadesNuevas.push({
            tipo: IncompatibilitiesType.MANUAL,
            incompatibility: incomp.observacion,
          });
        }
      }
    });
    return incompatibilidadesNuevas;
  }
  public chequearIncompatibilidadesManualesProductos(
    producto: ProductInCompatibility<Product>,
    product: Product,
  ): Array<Incompatibilities> {
    const incompatibilidadesNuevas: Array<Incompatibilities> = [];
    const listaIncompatibilidadesManuales = this.prodIncompatibles.filter(
      (prod) =>
        prod.idProductoA == producto.product.id_producto ||
        prod.idProductoB == producto.product.id_producto,
    );
    if (!listaIncompatibilidadesManuales?.length) {
      return [];
    }
    listaIncompatibilidadesManuales.forEach((incomp) => {
      if (
        (producto.product.id_producto == incomp.idProductoA &&
          incomp.idProductoB == product.id_producto) ||
        (producto.product.id_producto == incomp.idProductoB &&
          incomp.idProductoA == product.id_producto)
      ) {
        incompatibilidadesNuevas.push({
          tipo: IncompatibilitiesType.MANUAL,
          incompatibility: incomp.observacion,
        });
      }
    });
    return incompatibilidadesNuevas;
  }

  public relacionCpuFamilia(armado: DatosArmado, familia?) {
    let productosAValidar = armado.cpu.lista_productos;
    if (familia) {
      productosAValidar = productosAValidar?.map((cpu) => {
        if (cpu?.product.id_subcategoria !== (familia == 26 ? 27 : 48)) {
          cpu.incompatibilities.push({
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: `No pertenece a la familia ${familia == 26 ? 'AMD' : 'Intel'}`,
          });
        }
        return cpu;
      });
    }
    return productosAValidar;
  }
}
